import {
  getToken,
  getUser,
} from "../../../../Components/Helpers/Utilities/Common";
import {
  postAPICallwithFile,
  postAPICall,
  getWithParamsAPICall,
  postQrAPICallwithFile,
} from "../../../../Components/Helpers/API/axiosMethodCall";
import axios from "axios";

//POST API -- append a new data to the db
export const createPatient = async (info, file, master_patient_id) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("attachment", file || "");
    formData.append("master_patient_id", master_patient_id || "");
    formData.append("last_name", info.last_name);
    formData.append("first_name", info.first_name);
    formData.append("middle_name", info.middle_name || "");
    formData.append("suffix", info.suffix);
    formData.append("birthdate", info.birthdate);
    formData.append("contact_no", info.contact_no);
    formData.append("email", info.email);
    formData.append("sex", info.sex);
    formData.append("emergency_contact", info.emergency_contact);
    formData.append("emergency_contact_no", info.emergency_contact_no);
    formData.append("relation_w_contact", info.relation_w_contact);
    formData.append("senior_id", info.senior_id);
    formData.append("pwd_id", info.pwd_id);
    formData.append("country", info.country);
    formData.append("province", info.province);
    formData.append("city", info.city);
    formData.append(
      "barangay",
      info.country === "PHILIPPINES" ? info.barangay : ""
    );
    formData.append("street", info.street);
    formData.append("zip_code", info.zip_code);
    formData.append("civil_status", info.civil_status);
    formData.append("occupation", info.occupation);
    formData.append("nationality", info.nationality);
    formData.append("religion", info.religion);
    formData.append("remarks", info.remarks || "");

    if (info.ph_check) {
      formData.append("phic_membership_type", info.phic_membership_type);
      formData.append("phic_pin", info.phic_pin);

      if (info.phic_membership_type === "dependent") {
        formData.append("phic_dependent_pin", info.phic_dependent_pin);
      } else {
        formData.append("phic_dependent_pin", "");
      }

      formData.append("phic_first_name", info.phic_first_name);
      formData.append("phic_middle_name", info.phic_middle_name);
      formData.append("phic_last_name", info.phic_last_name);
      formData.append("phic_extension_name", info.phic_extension_name);
      formData.append("phic_birthdate", info.phic_birthdate);
      formData.append("phic_contact_no", info.phic_contact_no);
      formData.append("phic_enlistment_date", info.phic_enlistment_date);
      formData.append("phic_enlistment_status", info.phic_enlistment_status);
      formData.append("phic_package_type", info.phic_package_type);
      formData.append("phic_atc", info.phic_atc);
      if (info.liveness_check_screenshot) {
        formData.append("liveness_check_screenshot", info.liveness_check_screenshot);
      }
    } else {
      formData.append("phic_membership_type", "");
      formData.append("phic_pin", "");
      formData.append("phic_dependent_pin", "");
      formData.append("phic_first_name", "");
      formData.append("phic_middle_name", "");
      formData.append("phic_last_name", "");
      formData.append("phic_extension_name", "");
      formData.append("phic_birthdate", "");
      formData.append("phic_contact_no", "");
      formData.append("phic_enlistment_date", "");
      formData.append("phic_enlistment_status", "");
      formData.append("phic_package_type", "");
      formData.append("phic_atc", "");
    }
    // file.map((val) => {
    //     formData.append("attachments[]", val.file);
    // });
    
    // Log FormData contents for debugging
    console.log("createPatient FormData contents:");
    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`${key}:`, { name: value.name, size: value.size, type: value.type });
      } else {
        console.log(`${key}:`, value);
      }
    }
    
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "patients/create",
      formData,
      true
    );
    return response;
  } catch (error) {
    return error;
  }
};


export const createPatientCSR = async (info, file) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("attachment", file || "");
    formData.append("last_name", info.last_name);
    formData.append("first_name", info.first_name);
    formData.append("middle_name", info.middle_name || "");
    formData.append("suffix", info.suffix);
    formData.append("birthdate", info.birthdate);
    formData.append("contact_no", info.contact_no);
    formData.append("email", info.email);
    formData.append("sex", info.sex);
    formData.append("emergency_contact", info.emergency_contact);
    formData.append("emergency_contact_no", info.emergency_contact_no);
    formData.append("relation_w_contact", info.relation_w_contact);
    formData.append("senior_id", info.senior_id);
    formData.append("pwd_id", info.pwd_id);
    formData.append("country", info.country);
    formData.append("province", info.province);
    formData.append("city", info.city);
    formData.append("origin", "emr");
    formData.append(
      "barangay",
      info.country === "PHILIPPINES" ? info.barangay : ""
    );
    formData.append("street", info.street);
    formData.append("zip_code", info.zip_code);
    formData.append("civil_status", info.civil_status);
    formData.append("occupation", info.occupation);
    formData.append("nationality", info.nationality);
    formData.append("religion", info.religion);
    formData.append("remarks", info.remarks || "");

    if (info.ph_check) {
      formData.append("phic_membership_type", info.phic_membership_type);
      formData.append("phic_pin", info.phic_pin);

      if (info.phic_membership_type === "dependent") {
        formData.append("phic_dependent_pin", info.phic_dependent_pin);
      } else {
        formData.append("phic_dependent_pin", "");
      }

      formData.append("phic_first_name", info.phic_first_name);
      formData.append("phic_middle_name", info.phic_middle_name);
      formData.append("phic_last_name", info.phic_last_name);
      formData.append("phic_extension_name", info.phic_extension_name);
      formData.append("phic_birthdate", info.phic_birthdate);
      formData.append("phic_contact_no", info.phic_contact_no);
      formData.append("phic_enlistment_date", info.phic_enlistment_date);
      formData.append("phic_enlistment_status", info.phic_enlistment_status);
      formData.append("phic_package_type", info.phic_package_type);
      formData.append("phic_atc", info.phic_atc);
      if (info.liveness_check_screenshot) {
        formData.append("liveness_check_screenshot", info.liveness_check_screenshot);
      }
    } else {
      formData.append("phic_membership_type", "");
      formData.append("phic_pin", "");
      formData.append("phic_dependent_pin", "");
      formData.append("phic_first_name", "");
      formData.append("phic_middle_name", "");
      formData.append("phic_last_name", "");
      formData.append("phic_extension_name", "");
      formData.append("phic_birthdate", "");
      formData.append("phic_contact_no", "");
      formData.append("phic_enlistment_date", "");
      formData.append("phic_enlistment_status", "");
      formData.append("phic_package_type", "");
      formData.append("phic_atc", "");
    }
    // file.map((val) => {
    //     formData.append("attachments[]", val.file);
    // });
    
    // Log FormData contents for debugging
    console.log("createPatient FormData contents:");
    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`${key}:`, { name: value.name, size: value.size, type: value.type });
      } else {
        console.log(`${key}:`, value);
      }
    }
    
    const response = await postQrAPICallwithFile(
      process.env.REACT_APP_LINK_CSR + "patients/create",
      formData
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getPatients = async () => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "patients/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getPatientID = async (patient_id, page_num, patient_name) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "patients/search",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id,
        page: page_num.page,
        name_search: patient_name,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const editAPatient = async (info, patient_id, file) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("patient_id", patient_id);
    formData.append("last_name", info.last_name);
    formData.append("first_name", info.first_name);
    formData.append("middle_name", info.middle_name);
    formData.append("suffix", info.suffix);
    formData.append("birthdate", info.birthdate);
    formData.append("contact_no", info.contact_no);
    formData.append("email", info?.email || "");
    formData.append("sex", info.sex);
    formData.append("emergency_contact", info.emergency_contact || "");
    formData.append("emergency_contact_no", info.emergency_contact_no || "");
    formData.append("relation_w_contact", info.relation_w_contact || "");
    formData.append("senior_id", info.senior_id || "");
    formData.append("pwd_id", info.pwd_id || "");
    formData.append("country", info.country);
    formData.append("province", info.province);
    formData.append("city", info.city);
    formData.append(
      "barangay",
      info.country === "PHILIPPINES" ? info.barangay : ""
    );
    formData.append("street", info.street);
    formData.append("zip_code", info.zip_code);
    formData.append("civil_status", info.civil_status || "");
    formData.append("occupation", info.occupation || "");
    formData.append("nationality", info.nationality || "");
    formData.append("religion", info.religion || "");
    formData.append("remarks", info.remarks || "");
    formData.append("attachment", file || "");
    // formData.append("attachment_ids[]", info.profile_picture_id || null);
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "patients/update",
      formData,
      true
    );

    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const deletePatient = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "patients/delete",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const getScannedFiles = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "patients/scanned_files",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const Icd10Api = async (data) => {
  try {
    const response = await fetch(
      "https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&terms=" +
        data
    );
    const responseData = await response.json();

    return { data: responseData };
  } catch (error) {
    return { error: error.message };
  }
};

export const fetchPatientSearch = async (data) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "patients/search",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ""),
        patient_id: data?.id,
        page: data?.page,
        name_search: data?.search,
      }
    );
    return { data: response?.data };
  } catch (error) {
    return { error: error?.response };
  }
};

export const getFileByUrl = async (file_url) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_LINK + "files/get_file",
      {
        headers: {
          "api-key": process.env.REACT_APP_API_KEY,
        },
        params: {
          requester: getUser(),
          token: getToken(),
          file: file_url || "",
        },
        responseType: "blob",
      }
    );
    const contentType = response.headers["content-type"] || "application/octet-stream";
    const blob = new Blob([response.data], { type: contentType });
    const objectUrl = URL.createObjectURL(blob);
    return { data: { objectUrl } };
  } catch (error) {
    return { error: error.response };
  }
};

export const updatePhilhealthRecord = async (
  philhealthForm,
  patientDetails
) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("patient_id", patientDetails.id);
    formData.append("phic_membership_type", philhealthForm.patient_type);
    formData.append("phic_pin", philhealthForm.member_pin);
    if (philhealthForm.patient_type === "dependent") {
      formData.append("phic_dependent_pin", philhealthForm.dependent_pin);
    } else {
      formData.append("phic_dependent_pin", "");
    }
    formData.append("phic_first_name", philhealthForm.first_name);
    formData.append("phic_middle_name", philhealthForm.middle_name);
    formData.append("phic_last_name", philhealthForm.last_name);
    formData.append("phic_extension_name", philhealthForm.extension_name);
    formData.append("phic_birthdate", philhealthForm.birthdate);
    formData.append("phic_contact_no", philhealthForm.mobile_number);
    formData.append("phic_enlistment_date", philhealthForm.enlistment_date);
    formData.append("phic_enlistment_status", philhealthForm.enlistment_status);
    formData.append("phic_package_type", philhealthForm.package_type);
    formData.append("phic_atc", philhealthForm.atc);

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "patients/update_philhealth",
      formData,
      true
    );

    return response;
  } catch (error) {
    // return error;
    return { error: error?.response };
  }
};
